import axios from "@/axios-service";
import { AxiosResponse } from "axios";
import { classToPlain } from "class-transformer";
import { RiskReportRequest, SentinelaReportRequest } from "./types";


const MS_URL = '/senana/api/report/v1';

export const getSentinelaReport = async (request: SentinelaReportRequest): Promise<AxiosResponse<Blob>> => axios
  .post(`${MS_URL}/sentinela`, classToPlain(request), {responseType: 'blob'});

export const getDocumentToCarReport = async (request: string[]): Promise<AxiosResponse<Blob>> => axios
  .post(`${MS_URL}/doc-to-car`, classToPlain(request), {responseType: 'blob'});

export const getDocumentToEgReport = async (request: string[]): Promise<AxiosResponse<Blob>> => axios
  .post(`${MS_URL}/doc-to-economic-group`, classToPlain(request), {responseType: 'blob'});

export const getRiskReport = async (request: RiskReportRequest): Promise<AxiosResponse<Blob>> => axios
  .post(`${MS_URL}/risk-report`, classToPlain(request), {responseType: 'blob'});
